import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";

var _templateObject,
    _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ImportEstimation/components/DifficultConditions/ConditionLayout.styled.ts",
    _templateObject2,
    _templateObject3,
    _templateObject4,
    _templateObject5,
    _templateObject6,
    _templateObject7,
    _templateObject8;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from 'styled-components';
import { Popover as PopoverInit } from '@mui/material';
export var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  background-color: #f4f4f8;\n  border-radius: 4px;\n"])));
export var Content = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  padding: 14px 8px 14px 14px;\n  width: 100%;\n"])));
export var FirstLine = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  margin-bottom: 14px;\n"])));
export var CloseButtonWrap = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  margin: 18px 8px 0 0;\n"])));
export var WarningContainer = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  padding: 24px 24px 20px 24px;\n"])));
export var WarningActions = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 24px;\n  gap: 12px;\n"])));
export var WarningDeleteText = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-size: 20px;\n  line-height: 21px;\n  letter-spacing: 0.1px;\n  color: rgb(53, 59, 96);\n"])));
export var Popover = styled(PopoverInit)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  & .MuiPaper-root {\n    box-shadow: 0px 9px 30px rgba(53, 59, 96, 0.3);\n    border-radius: 4px;\n  }\n"])));